<template>
    <FullWidthMessage v-qa="'error-500'">
        <template #title>
            <slot name="title">
                {{ t('globals.critical_error_title') }}
            </slot>
        </template>

        <template #default>
            <slot name="message">
                <p>{{ t('globals.critical_error_message') }}</p>

                <p v-if="errors.amazonTraceId">
                    {{
                        t('globals.contact_on_error_with_amzn_trace_id', {
                            amznTraceId: errors.amazonTraceId,
                        })
                    }}
                </p>

                <p v-else>
                    {{ t('globals.contact_on_error') }}
                </p>

                <div
                    v-if="
                        (isAdmin || showServerErrorsForNonAdmin) &&
                        errors.serverErrors.length
                    "
                >
                    Errors:
                    <div
                        v-for="(error, key) in errors.serverErrors"
                        :key="key"
                    >
                        {{ error.message }} (Reference:
                        {{ error.sentryEventId || 'N/A' }})
                    </div>

                    <br v-if="!!$slots['default']" />
                </div>
            </slot>

            <slot name="default"></slot>
        </template>
    </FullWidthMessage>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import type { ErrorCollectionWithTraces } from '@/helpers/errors'
import { useIsAdmin } from '@/components/app/isAdmin'

import FullWidthMessage from '@/components/ui/FullWidthMessage.vue'

const isAdmin = useIsAdmin()

defineProps<{
    errors: ErrorCollectionWithTraces
    showServerErrorsForNonAdmin?: boolean
}>()

const { t } = useI18n()
</script>
